// extracted by mini-css-extract-plugin
export default {"carousel":"styles-module__carousel--oojFv","closeButton":"styles-module__closeButton--jXgBX"};